import React, {PropsWithChildren} from 'react';
import {AuthContextProvider} from './context/auth.context';

interface Props {}

export default function AppContext({children}: PropsWithChildren<Props>) {
  return <AuthContextProvider>{children}</AuthContextProvider>;
}
